import PropTypes from 'prop-types';
import InvoiceQuickEditorDrawerPreviewDesktop from './InvoiceQuickEditorDrawerPreviewDesktop';
import InvoiceQuickEditorDrawerPreviewMobile from './InvoiceQuickEditorDrawerPreviewMobile';

export default function InvoiceQuickEditorDrawerPreview(props) {
    const { compactMode, id } = props;

    const Preview = compactMode ? InvoiceQuickEditorDrawerPreviewMobile : InvoiceQuickEditorDrawerPreviewDesktop;

    return <Preview id={id} />;
}

InvoiceQuickEditorDrawerPreview.propTypes = {
    compactMode: PropTypes.bool,
    id: PropTypes.string,
};
